import type { AdminAllProjectsMcpKey, McpKeyListResponse, McpKeyRotateResponse } from '../types/api'
import { apiClient } from './client'

export async function listMcpKeys(): Promise<McpKeyListResponse> {
  return apiClient.get<McpKeyListResponse>('/settings/mcp-keys')
}

export async function getAdminAllProjectsKey(): Promise<AdminAllProjectsMcpKey> {
  return apiClient.get<AdminAllProjectsMcpKey>('/admin/mcp-keys/all-projects')
}

export async function rotateOwnMcpKey(): Promise<McpKeyRotateResponse> {
  return apiClient.post<McpKeyRotateResponse>('/settings/mcp-keys/rotate')
}

export async function rotateAdminAllProjectsKey(): Promise<McpKeyRotateResponse> {
  return apiClient.post<McpKeyRotateResponse>('/admin/mcp-keys/all-projects/rotate')
}
